import SelectCustom from "@ui/select/selectCustom/SelectCustom";
import {useTranslation} from "react-i18next";


const SelectHours = ({onChange, value, size = 'small'}) => {

    const {t} = useTranslation()

    const hours = Array.from({length: 24}, (_, i) => {
        return {
            value: i,
            label: i > 9 ? i : `0${i}`
        }
    });

    return (
        <SelectCustom
            label={t('base.hours')}
            size={size}
            value={value}
            onChange={onChange}
            data={hours}
        />
    )
}

export default SelectHours;